import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import FamilySvg from 'images/icons/fc-marketing/family.svg'
import GolfHoleSvg from 'images/icons/fc-marketing/golf-hole.svg'
import HatSvg from 'images/icons/fc-marketing/hat.svg'
import Container from 'components/program-marketing/container'
import { HowSectionList } from 'components/program-marketing/how-section-list'

const useStyles = makeStyles(theme => ({
  orange: {
    background: theme.palette.primary.main,
  },
  green: {
    background: theme.palette.secondary.main,
  },
  blue: {
    background: theme.palette.background.dark,
  },
}))

const HowSection = () => {
  const classes = useStyles()
  const howItWorksListPoints = [
    {
      title: 'Family Teams',
      text:
        'In PGA Family Golf, your family is your team. Think parents and grandparents, brothers and sisters, aunts and uncles… all playing for the same, multi-generational team.',
      icon: FamilySvg,
      iconBg: classes.orange,
    },
    {
      title: 'Friendly Formats',
      text:
        "Welcoming formats and course setups to accommodate all abilities. It's a friendly competition that everyone walks away with quality time well spent as a family.",
      icon: GolfHoleSvg,
      iconBg: classes.green,
    },
    {
      title: 'Coaches',
      text:
        'Coached by the best in the business, the PGA Family Golf is exclusively led by PGA and LPGA Professionals.',
      icon: HatSvg,
      iconBg: classes.blue,
    },
  ]

  return (
    <Container data-testid="how-section">
      <Box mb={2}>
        <Typography variant="h3" color="primary">
          How it works
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="h2">
          What to expect when participating in PGA Family Golf
        </Typography>
      </Box>
      <Box mb={4}>
        <Typography variant="body1">
          In sports, your team is your family. With PGA Family Golf, your family
          is your team.
        </Typography>
      </Box>
      <HowSectionList data={howItWorksListPoints} />
    </Container>
  )
}

export default HowSection
